// src/components/PunchClockLayout.jsx
import React from 'react';

const PunchClockLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <div className="max-w-4xl w-full bg-white shadow p-6 rounded">
        {children}
      </div>
    </div>
  );
};

export default PunchClockLayout;
